import React from 'react'

export default function HeaderSkills() {
  return (
    <div className="header__info title long">
          <span>POKéMON SKILLS</span>
    </div>
  )
}
